import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Label,
  Input,
  Table,
  Spinner,
  FormGroup
} from "reactstrap";
import ContentForm from "./ContentForm";
import { Style, Text, Fill, Stroke, Circle } from "ol/style.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faSearch } from "@fortawesome/free-solid-svg-icons";

class ContentPanel extends Component {

  componentDidMount() {

  }

  /////////////////////////////////////////////
  //Highlight parcel on map when mouse is over that parcel in the selected parcel table
  onMouseOverParcelTable = (feature) => {
    const selectStyle = new Style({
      fill: new Fill({
        color: 'rgba(250, 22, 22, 0.7)',
      }),
      stroke: new Stroke({
        color: 'rgba(250, 22, 22, 1.0)',
        width: 2,
      }),
    });
    feature.setStyle(selectStyle);
  };

  onMouseOutParcelTable = (feature) => {
    feature.setStyle(null);
  };
  /////////////////////////////////////////////


  render() {
    const { setSelectParcels, setDrawPolygon, useCurrentGeometry, clearCurrentGeometry, geometryCreationMode, rawFeatures, buffer, parcelSelectionLoading,
      setBuffer, validatedFeature, removeParcel, goBack, zoomToExtent, exportItems, setExportItems, exportFormats, setExportFormats, setLoading, setInfoMessage } = this.props;
      
    return (
      <Container style={{padding:15}}>
        {!validatedFeature && 
          <>
            <hr />
            <Row>
              <Col md="12" className="project-row-title" style={{textAlign: 'center'}}>
              Define Project Area
              </Col>
            </Row>
            <hr/>
            <Row>
              <Col md="12">
                {rawFeatures.length==0  &&
                <Row>
                  <Col md="5">
                  <Button className="rounded-pill" onClick={setSelectParcels} color={geometryCreationMode==='SelectParcels' ? 'success' : 'primary'} style={{float:'right'}}>Select Parcels</Button>
                  </Col>
                  <Col md="2">
                    <div style={{textAlign:'center'}}>OR</div>
                  </Col>
                  <Col md="5">
                  <Button className="rounded-pill" onClick={setDrawPolygon}  color={geometryCreationMode==='DrawPolygon' ? 'success' : 'primary'} style={{float:'left'}}>Draw Polygon</Button>
                  </Col>
                </Row>}
              </Col>
            </Row>  
            {geometryCreationMode==='SelectParcels' && rawFeatures.length>0 && 
              <>
                <Row style={{marginTop:20}}>
                  <Table>
                    <thead>
                      <tr>
                        <th></th>
                        <th>APN</th>
                        <th>Address </th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                    {rawFeatures.map((item, i) => {
                      return (
                        <tr key={i} 
                          onMouseOver={()=>this.onMouseOverParcelTable(item)} 
                          onMouseOut={()=>this.onMouseOutParcelTable(item)} >
                          <td>
                            <FontAwesomeIcon
                              icon={faSearch}
                              size="2x"
                              style={{color:'black',paddingTop:10, cursor: 'pointer'}}
                              className=""
                              onClick={()=>zoomToExtent(item.getGeometry().getExtent())} />
                          </td>
                          <td>{item.get("PARCEL_NO")}</td>
                          <td>{item.get("SITE_FULL_ADDRESS")}</td>
                          <td>
                            <FontAwesomeIcon
                            icon={faTimes}
                            size="2x"
                            style={{color:'red',paddingTop:10, cursor: 'pointer'}}
                            className=""
                            onClick={()=>removeParcel(item)} />
                          </td>
                        </tr>
                      );
                    })}
                    </tbody>
                  </Table>
                </Row>
                {parcelSelectionLoading && <Row style={{textAlign:'center'}}>
                  <Spinner style={{marginLeft:'auto',marginRight:'auto'}}>
                    Loading...
                  </Spinner>
                </Row>}
              </>
            }
            {rawFeatures.length>0 && 
              <>
                <Row>
                  <Col md="12">
                    <Label style={{width:'100%', marginTop:30}} className="client-information__label">
                      <b>Optional Buffer Distance (feet):</b>
                      <Input
                        type="number"
                        value={buffer}
                        onChange={e => setBuffer(e.target.value)}
                      />
                    </Label>
                  </Col>
                </Row>
                <Row style={{margin:30, marginTop: 60, textAlign:'center'}}>
                  <Col md="6">
                    <Button className="rounded-pill"  color="primary" onClick={useCurrentGeometry} style={{width:'100%'}}>Use Selected Area</Button>
                  </Col>
                  <Col md="6">
                      <Button className="rounded-pill" color="danger" onClick={clearCurrentGeometry} style={{width:'100%'}}>Clear Selected Area</Button>
                    </Col>
                </Row>
              </>
            }
          </>
        }
        <ContentForm 
          exportItems={exportItems}
          setExportItems={setExportItems}
          exportFormats={exportFormats}
          setExportFormats={setExportFormats}
          rawFeatures={rawFeatures}
          validatedFeature={validatedFeature}
          setLoading={setLoading}
          setInfoMessage={setInfoMessage}
          goBack={goBack}
          />
      </Container>
    );
  }
}

export default ContentPanel;